import React from 'react'
import renderPrgImage from '../../source/programImg'

const containerStyle = {
    position: 'fixed',
    left: '38%',
    bottom: '2.5%',
    transform: 'translateX(-50%)',
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    padding: '10px 16px',
    background: 'rgba(255, 255, 255, 0.92)',
    borderRadius: '14px',
    boxShadow: '0 6px 20px rgba(0, 0, 0, 0.15)',
    zIndex: 2500,
}

const textStyle = {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    minWidth: '320px',
    color: '#1f1f1f',
    fontSize: '14px',
}

const titleStyle = {
    fontWeight: 600,
    fontSize: '15px',
}

const buttonStyle = {
    width: '44px',
    height: '44px',
    cursor: 'pointer',
    userSelect: 'none',
}

const AssemblyStepsSlideshow = ({
    slideIndex,
    totalSlides,
    title,
    instruction,
    onPrev,
    onNext,
}) => {
    if (!totalSlides) {
        return null
    }

    return (
        <div style={containerStyle}>
            <img
                style={buttonStyle}
                src={renderPrgImage('backBtn')}
                draggable="false"
                onClick={onPrev}
            />
            <div style={textStyle}>
                <div style={titleStyle}>{title}</div>
                <div>{instruction}</div>
                <div>
                    Slide {slideIndex + 1} of {totalSlides}
                </div>
            </div>
            <img
                style={buttonStyle}
                src={renderPrgImage('nextBtn')}
                draggable="false"
                onClick={onNext}
            />
        </div>
    )
}

export default AssemblyStepsSlideshow
